/**
 * localStorage key recording that this browser has shown the referral banner once.
 * Versioned (`.v1`) so the NEW badge can be deliberately re-introduced later.
 */
const STORAGE_KEY = 'vitalrev.referralBanner.seen.v1'

/**
 * True if this browser has already shown the referral banner.
 * Storage errors (private mode, disabled storage) are treated as "seen" so the
 * NEW badge is suppressed rather than shown forever.
 */
export function hasSeenReferralBanner(
  storage: Pick<Storage, 'getItem'> = window.localStorage,
): boolean {
  try {
    return storage.getItem(STORAGE_KEY) === '1'
  } catch {
    return true
  }
}

/** Record that the referral banner has been shown. Idempotent; storage errors ignored. */
export function markReferralBannerSeen(
  storage: Pick<Storage, 'setItem'> = window.localStorage,
): void {
  try {
    storage.setItem(STORAGE_KEY, '1')
  } catch {
    /* storage unavailable — NEW badge simply shows again on next load */
  }
}
